import {Navigate, Route, Routes} from "react-router-dom";
import Login from "../pages/authorization/Login";
import ForgotPassword from "../pages/authorization/ForgotPassword";
import SetPassword from "../pages/authorization/SetPassword";

const AuthRouter = () => {
    return (
        <Routes>
            <Route path="" element={<Navigate to='login'/>}/>

            <Route path="login" element={<Login/>}/>

            <Route path="forgot-password" element={<ForgotPassword/>}/>

            <Route path="set-password/:token" element={<SetPassword/>}/>

            <Route path="*" element={<Navigate to='login'/>}/>
        </Routes>
    );
};

export default AuthRouter;
